import { actionTypes } from '../../constants';
import {
  WEEKLY_BALANCE_ALERT_ENDPOINT,
  UPDATE_WEEKLY_BALANCE_ALERT_ENDPOINT,
} from '../../constants/urls';
import { RSAA } from 'redux-api-middleware';
import { X_BPI_VERSION_0_8_0 } from '../../constants/VersionConstants';
const {
  GET_WEEKLY_BALANCE_ALERT,
  GET_WEEKLY_BALANCE_ALERT_SUCCESS,
  GET_WEEKLY_BALANCE_ALERT_FAILURE,
  UPDATE_WEEKLY_BALANCE_ALERT,
  UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS,
  UPDATE_WEEKLY_BALANCE_ALERT_FAILURE,
  SHOW_BUTTON,
  TOGGLE_FLAG,
  DAY_SELECTED,
} = actionTypes;

export const getWeeklyBalanceAlert = () => ({
  [RSAA]: {
    endpoint: WEEKLY_BALANCE_ALERT_ENDPOINT,
    method: 'GET',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    types: [
      GET_WEEKLY_BALANCE_ALERT,
      GET_WEEKLY_BALANCE_ALERT_SUCCESS,
      GET_WEEKLY_BALANCE_ALERT_FAILURE,
    ],
  },
});

export const updateWeeklyBalanceAlert = (data, reqBody, activeElement) => ({
  [RSAA]: {
    endpoint: UPDATE_WEEKLY_BALANCE_ALERT_ENDPOINT.replace('{account_id}', data.account_id),
    method: 'PUT',
    headers: {
      'x-bpi-version': X_BPI_VERSION_0_8_0,
    },
    body: JSON.stringify(reqBody),
    types: [
      UPDATE_WEEKLY_BALANCE_ALERT,
      UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS,
      {
        type: UPDATE_WEEKLY_BALANCE_ALERT_FAILURE,
        meta: { activeElement },
      },
    ],
  },
});

export const showButtonOptions = (isDisabled) => ({
  type: SHOW_BUTTON,
  isDisabled,
});

export const toggleCheck = (toggleFlag) => ({
  type: TOGGLE_FLAG,
  toggleFlag,
});

export const selectedDay = (daySelected) => ({
  type: DAY_SELECTED,
  daySelected,
});
